// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"163":"10a671284c3087404552","564":"0a2da059e446dba47b4d","874":"3fbeae7bb757fc12cda1","880":"17bfa1838a03623de960","942":"0f7debbdee56c702a7ec"}[chunkId] + ".css";
};